import classNames from '@sindresorhus/class-names';
import {useEffect, useRef, useState} from 'react';

import chevron from '@web-landing/assets/images/chevron.svg';

import styles from './Accordion.module.scss';

type Props = {
  title: string | React.ReactNode;
  content: string | React.ReactNode;
  opened: boolean;
  onClick?: () => void;
  classes?: {
    root?: string;
    title?: string;
  };
};

const PADDING_TOP = 16;

export const Accordion = ({
  content,
  opened,
  title,
  onClick: onHandleClick,
  classes,
}: Props) => {
  const [isOpened, setOpened] = useState(opened);
  const onClick = () => {
    setOpened(!isOpened);
    onHandleClick?.();
  };
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    ref.current &&
      ref.current.style.setProperty(
        '--height-variable',
        `${ref.current.scrollHeight + PADDING_TOP}px`,
      );
  }, []);

  return (
    <div className={classNames(styles.accordion, classes?.root)}>
      <div
        className={classNames(styles.accordion__title, classes?.title)}
        onClick={onClick}
      >
        {typeof title === 'string' ? (
          <h3 className={styles.accordion__title_text}>{title}</h3>
        ) : (
          title
        )}
        <img
          className={classNames(styles.accordion__title_icon, {
            [styles.accordion__title_iconOpened]: isOpened,
          })}
          src={chevron.src}
        />
      </div>
      <div
        ref={ref}
        className={classNames(styles.accordion__content, {
          [styles.accordion__content_closed]: !isOpened,
        })}
      >
        {content}
      </div>
    </div>
  );
};
